export class ResponseDetalleEstado{
    payload:DetalleEstado;

    constructor(){
        this.payload = new DetalleEstado();
    }
}


export class DetalleEstado{
    estadoPrincipal:number;
    subEstadoAutoevaluacion:number;
    subEstadoValidacion:number;
    fechaVencimientoAutoevaluacion:Date;
    fechaEnvioAutoevaluacion:Date;
    fechaValidacionJ1:Date;
    fechaValidacionJ2:Date;
    fechaValidacionFinalizada:Date;
    fechaValidacionDescargaIR:Date;
    fechaValidacionVencimientoApelacion:Date;
    fechaValidacionApelacion:Date;
    planStatus:number;


    constructor(){
        this.estadoPrincipal = 0;
        this.subEstadoAutoevaluacion = 0;
        this.subEstadoValidacion = 0;
        this.fechaVencimientoAutoevaluacion=new Date();
        this.fechaEnvioAutoevaluacion=new Date();
        this.fechaValidacionJ1=new Date();
        this.fechaValidacionJ2=new Date();
        this.fechaValidacionFinalizada=new Date();
        this.fechaValidacionDescargaIR=new Date();
        this.fechaValidacionVencimientoApelacion=new Date();
        this.fechaValidacionApelacion=new Date();
        this.planStatus=0;
    }
}

 